(function () {
  'use strict';

  angular.module('app').component('serviceItemsPage', serviceItemListCtrl());

  function serviceItemListCtrl() {
    return {
      bindings: {},
      controller: ServiceItemListCtrl,
      controllerAs: 'vm',
      templateUrl: './app/ajs/service-items/service-items-page.component.html',
    };
  }

  ServiceItemListCtrl.$inject = [
    '$location',
    'AbilityService',
    'SessionService',
    'ServiceItemService',
  ];

  function ServiceItemListCtrl($location, AbilityService, SessionService, ServiceItemService) {
    let vm = this;

    vm.permissions = {
      canCreate: AbilityService.can('create_serviceitem_accountadmin'),
    };

    vm.userLanguageCode = SessionService.getUserLanguage().code;

    // Methods
    vm.createItem = createItem;
    vm.onShowItem = onShowItem;

    // Initializers
    // getDefaultLanguage();
    getItems();

    // function getDefaultLanguage(){
    //     LanguageService.getLanguages({ get: 'is_default', skip_check_role: true }).then(function () {
    //         vm.defaultLanguage = LanguageService.items.lang;
    //     });
    // }

    function getItems() {
      vm.loadingItems = true;
      ServiceItemService.getServiceItems().then(function (data) {
        vm.items = data.items;
        vm.meta = data.meta;

        vm.totalItems = vm.meta.totalItems;

        vm.loadingItems = false;
      });
    }

    function createItem() {
      $location.path('/service_items/new');
    }

    function onShowItem(item, mode) {
      $location.path(`/service_items/${item.id}`).search({ mode: mode });
    }
  }
})();
